module.exports = "<p>\n  store-priority works!\n</p>\n"